import React from 'react';

import { callApi } from 'helpers/callApi/callApi';
import AppModal from 'components/modal/appModal';
import { UnlockTemplateMpdalProps } from './UnlockTemplateModal.types';

export const UnlockTemplateModalContent = ({
  id,
  unlockTemplate,
  data: { event },
  close,
}: UnlockTemplateMpdalProps) => {
  const handleSubmit = () => {
    callApi({
      action: () => unlockTemplate(event.id),
      onSuccess: close,
    });
  };

  return (
    <AppModal
      id={id}
      title="Unlock template"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <p>
        Are you sure you want to unlock the template of <strong>{event.name || 'unnamed'}</strong> event?
      </p>
    </AppModal>
  );
};
